import DashBoard from './DashBoard';

export default DashBoard;